import { computed } from '@vue/composition-api';
import { date } from '@/util/formatters';
import { SurveyStatus } from '@/api/v2/requests/surveys';
import { DummyFilter } from '@/components/Table/dummy-filter';
import { surveyStatusStyles } from '@/views/Brand/Surveys/_constants/survey-status';
export const usePlaceManagerSurveyColumns = (ctx) => {
    const columns = computed(() => [
        {
            field: 'internalNumber',
            headerName: ctx.root.$t('table-header.internal-number').toString(),
            cellClass: 'ag-cell--bold',
            width: 128,
            minWidth: 128,
            flex: 0,
            sortable: true,
            filter: DummyFilter,
            floatingFilter: true,
            floatingFilterComponent: 'FloatingTextFilter',
            suppressFloatingFilterButton: true,
            suppressHeaderFilterButton: true,
        },
        {
            field: 'title',
            headerName: ctx.root.$t('brand-surveys.table.title').toString(),
            minWidth: 415,
            sortable: true,
            filter: DummyFilter,
            floatingFilter: true,
            floatingFilterComponent: 'FloatingTextFilter',
            suppressFloatingFilterButton: true,
            suppressHeaderFilterButton: true,
            cellRenderer: 'SurveyTitleCell',
        },
        {
            field: 'createdAt',
            headerName: ctx.root
                .$t('table-header.date-of-first-publication')
                .toString(),
            minWidth: 232,
            width: 220,
            sortable: true,
            filter: DummyFilter,
            floatingFilter: true,
            floatingFilterComponent: 'FloatingDatepickerFiler',
            suppressFloatingFilterButton: true,
            suppressHeaderFilterButton: true,
            cellRenderer: (params) => date(params?.data?.createdAt),
        },
        {
            field: 'aggregatedStatus',
            headerName: ctx.root.$t('brand-surveys.table.status'),
            width: 300,
            flex: 1,
            cellRenderer: 'SurveyStatusBadge',
            cellRendererParams: (params) => {
                return {
                    status: params?.data?.aggregatedStatus,
                    style: {
                        padding: '4px 8px',
                    },
                };
            },
            filter: DummyFilter,
            floatingFilter: true,
            floatingFilterComponent: 'FloatingSelectFilter',
            floatingFilterComponentParams: () => ({
                options: Object.values(SurveyStatus).map((status) => ({
                    value: status,
                    label: ctx.root.$t(`survey-status.${status}`).toString(),
                    style: {
                        ...surveyStatusStyles[status],
                        padding: '4px 8px',
                    },
                })),
                getLabel: (status) => {
                    return ctx.root.$t(`survey-status.${status}`).toString();
                },
                style: {
                    maxWidth: '240px',
                },
            }),
            suppressFloatingFilterButton: true,
        },
    ]);
    return {
        columns,
    };
};
